"use client";

import { c as _c } from "react/compiler-runtime";
import React, { memo } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import ImageComponent from "@/components/ui/image";
import HeroDiwaliDesktopBg from "@/assets/images/v2/hero-diwali-desktop-bg.webp";
import { THE_DIWALI_FAVOURITES_COLLECTION_ID, MEANINGFUL_DIWALI_COLLECTION_ID } from "@/constants/product";
export const DiwaliDesktopHero = memo(() => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 z-0"><ImageComponent className="w-full h-full object-cover" alt="Handcrafted Art Glass Puja Diya - Ambar Jyot glowing with warm light" src={HeroDiwaliDesktopBg} fill={true} sizes="100vw" fetchPriority="high" loading="eager" /><div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-transparent" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="font-outfit text-sm uppercase tracking-[0.3em] mb-4 text-[#ffdcc7]">The Art of Gifting</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h1 className="font-lora text-5xl md:text-6xl font-bold leading-tight mb-8">This Diwali,<br /><span className="font-normal text-3xl md:text-4xl">Do Something Meaningful.</span></h1>;
    t3 = <p className="font-outfit text-lg md:text-xl text-white/90 mb-10 max-w-xl leading-relaxed font-light">Celebrate Diwali with meaningful gifts that honor tradition, support master artisans and bring joy to the people who matter most.</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href={`/listing/the-diwali-favourites?id=${THE_DIWALI_FAVOURITES_COLLECTION_ID}`} prefetch={true}><Button className="bg-[#037A6A] hover:bg-[#005f52] px-10 py-5 rounded font-lora font-semibold uppercase tracking-[0.1em] transition-all shadow-lg hover:shadow-[0_4px_20px_rgba(3,122,106,0.5)] active:scale-95 text-white h-auto">EXPLORE DIWALI FAVOURITES</Button></Link>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-[#101010] w-full h-full flex relative overflow-hidden">{t0}<div className="relative z-10 h-full flex flex-col justify-center px-12 md:px-24 text-white max-w-4xl">{t1}{t2}{t3}<div className="flex gap-4">{t4}<Link href={`/listing/meaningful-diwali?category_id=${MEANINGFUL_DIWALI_COLLECTION_ID}`} prefetch={true}><Button variant="outline" className="w-full inline-flex items-center justify-center tracking-[0.1em] uppercase px-10 py-5 rounded border border-[#ffb380]/60 hover:border-[#ffdcc7] text-[#ffdcc7] hover:text-white bg-black/25 transition-all duration-300 hover:bg-black/40 h-auto font-bold">explore all festive collections</Button></Link></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
});
DiwaliDesktopHero.displayName = "DiwaliDesktopHero";